import React, { useEffect, useState } from "react";
import { BsSearch, BsEmojiFrownFill, BsFillTrash2Fill  } from "react-icons/bs";
import ReactModal from "react-modal";
import trashbin from "./icons/trash-2.svg";

export const RecentChats = ({ user_uuid, fetchMessages, reloadTrigger, selectedconversationId }) => {
  const [conversations, setConversations] = useState([]);
  const [searchTemp, setSearchTemp] = useState("");
  const [error, setError] = useState(null);
  const [showConvDeleteModal, setShowConvDeleteModal] = useState(false);
  const [deleteConversationId, setDeleteConversationId] = useState(null);

  const fetchConversations = async () => {
    try {
      const search = searchTemp.trim() || null;
      const payload = {
        user_uuid,
        ...(search && { search }),
      };

      const response = await fetch(`${process.env.REACT_APP_CRM}/ai/conversations/all`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      const data = result.data || [];
      setConversations(data);
      setError(null);
    } catch (err) {
      console.error("Failed to fetch Conversations", err);
      setError("Something went wrong while fetching conversations.");
    }
  };

  const handleDeleteConversation = (conversation_id) => {
      // Call the API to delete the document 
      fetch(`${process.env.REACT_APP_CRM}/ai/conversations/delete`, {
          method: "POST",
          body: JSON.stringify({
            conversation_id,
            user_uuid,
          }),
          headers: { "Content-Type": "application/json" },
      })
      .then((response) => {
          if (response.ok) {

            setConversations((prev) => prev.filter((conv) => conv.conversation_id !== conversation_id));
            // Document deleted successfully, refresh the documents list
            //fetchDocuments();

          } else {
              console.error("Failed to delete document", response.statusText);
          }
      })
  };

  useEffect(() => {
  if (!user_uuid) return;
  // If search changed, debounce
  if (searchTemp) {
    const delayDebounce = setTimeout(() => {
      fetchConversations();
    }, 500);

    return () => clearTimeout(delayDebounce);
  } else {

    fetchConversations();
  }
}, [user_uuid, reloadTrigger, searchTemp]);

  const groupConversationsByDate = (items) => {
    const groups = { today: [], yesterday: [], earlier: [] };
    const now = new Date();
    const todayStr = now.toDateString();

    const yesterday = new Date();
    yesterday.setDate(now.getDate() - 1);
    const yesterdayStr = yesterday.toDateString();

    items.forEach((conv) => {
      const createdAt = new Date(conv.created_date);
      const createdStr = createdAt.toDateString();

      if (createdStr === todayStr) {
        groups.today.push(conv);
      } else if (createdStr === yesterdayStr) {
        groups.yesterday.push(conv);
      } else {
        groups.earlier.push(conv);
      }
    });

    return groups;
  };

  const renderGroup = (label, items) => {
    if (items.length === 0) return null;

    return (
      <div className="left-chatbox">
        <div className="post-left-chatbox">
          <div style={{ marginBottom: "1rem" }}>
            <h4>{label}</h4>
            {items.map((conv) => (
              <div
                key={conv.conversation_id}
                className={`single-chat ${selectedconversationId === conv.conversation_id ? "active" : ""}`}
                onClick={() => fetchMessages(conv.conversation_id, user_uuid)}
              >
                <div className="top">
                  <div className="top-left">
                    <div className="text">
                      {conv.conversation_title && conv.conversation_title.length > 50
                        ? `${conv.conversation_title.slice(0, 50)}...`
                        : conv.conversation_title || conv.conversation_id}
                    </div>
                     <button
                      className="delete-btn"
                      onClick={(e) => {
                          e.stopPropagation(); // Prevent triggering fetchMessages
                          setDeleteConversationId(conv.conversation_id); // set the document ID
                          setShowConvDeleteModal(true); // show the modal
                      }}
                    >
                      <img src = {trashbin} alt = "delete"/>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="chat-history">
      <div className="left-topbar" style={{ padding: "20px 10px 0px 10px" }}>
        <div className="alie-conv-search" style={{ height: "37px" }}>
          <button
            type="submit"
            style={{
              background: "#fff",
              padding: "8px 3px 8px 11px",
            }}
          >
            <BsSearch />
          </button>
          <input
            placeholder="Search for Chats"
            type="text"
            className="form-control input-f"
            name="search"
            id="search"
            autoComplete="off"
            onChange={(e) => setSearchTemp(e.target.value)}
            value={searchTemp}
            style={{
              padding: "0 0 0 5px",
              height: "35px",
              borderRadius: "6px",
            }}
          />
        </div>
      </div>

      <h2>Chat History</h2>

      {error && (
        <div className="error-message" style={{ color: "red", padding: "10px" }}>
          {error}
        </div>
      )}

      {conversations.length > 0 ? (
        (() => {
          const grouped = groupConversationsByDate(conversations);
          return (
            <div className="recent-chats">
              {renderGroup("Today", grouped.today)}
              {renderGroup("Yesterday", grouped.yesterday)}
              {renderGroup("Earlier", grouped.earlier)}
            </div>
          );
        })()
      ) : (
        <div className="recent-chats no-conversations">
          {searchTemp && conversations.length === 0 ? (
            <div>
              <BsEmojiFrownFill style={{ fontSize: "3rem", color: "#303030" }} />
              <p>No match found</p>
            </div>
          ) : null}
        </div>
      )}


      <ReactModal
          isOpen={showConvDeleteModal}
          onRequestClose={() => setShowConvDeleteModal(false)}
          className="styled-modal"
          overlayClassName="styled-modal-overlay"
          ariaHideApp={false}
          >
          <div className="p-4">
              <h5 className="fw-semibold mb-3"><strong>Delete Conversation</strong></h5>
              <p className="text-muted mb-4">
                  Are you sure you want to delete the this conversation? This action cannot be undone. 
              </p>
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '10px' }}>
              <button
                  className="btn btn-outline-secondary"
                  onClick={() => setShowConvDeleteModal(false)}
              >
                  Cancel
              </button>
              <button
                  className="btn btn-danger"
                  onClick={() => {
                  handleDeleteConversation(deleteConversationId); // use selectedDocId here
                  setShowConvDeleteModal(false);   // close modal after delete
                  }}
              >
                  Delete
              </button>
              </div>
          </div>
        </ReactModal>
    </div>
  );
};

export default RecentChats;



// WEBPACK FOOTER //
// ./src/components/ai/recentConversations.js